'use client'

import { createContext, Dispatch, SetStateAction, useContext, useState } from 'react'

export type CurrencyProtocol = {
  currency: string
  protocol?: string
  address?: string
  stableCoin?: boolean
}

interface SelectedItemContext {
  item: CurrencyProtocol
  setItem: Dispatch<SetStateAction<CurrencyProtocol>>
}

const SelectedItemContext = createContext<SelectedItemContext>({
  item: {
    currency: '',
    address: '',
  },
  setItem: () => {
    throw Error(
      'setItem function not initialized - wrap your component within SelectedItemContextProvider'
    )
  },
})

export const SelectedItemContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [item, setItem] = useState<CurrencyProtocol>({
    currency: '',
    address: '',
  })

  return (
    <SelectedItemContext.Provider value={{ item, setItem }}>
      {children}
    </SelectedItemContext.Provider>
  )
}

export const useSelectedItemContext = () => useContext(SelectedItemContext)
